import * as $ from "jquery";

/** Given an anchor element `$el`, this function will make it so that
    on clicking `$el`, the page will scroll smoothly to the
    element with id equal to the href tag of `$el`. **/
export function getSetScroll(headerHeight: number, mobileHeaderHeight: number, mobileWidth: number) {
    return function setScroll($el: any) {
        $el.on("click", function(event: any) {
            let scrollPosition = $(event.currentTarget.hash).offset().top;
            if (window.innerWidth > mobileWidth) {
                // substract the fixed header on desktop (on mobile the header is static)
                scrollPosition -= headerHeight;
            }
            else {
                scrollPosition -= mobileHeaderHeight;
            }
            $("html, body").animate({scrollTop: scrollPosition}, "slow");
            return false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/ts/set_scroll.ts